export const menuItemsContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2000,
  display: "flex",
  flexDirection: "column",
  background: "background",
  alignItems: "center",
  p: "20px",
};

export const menuItem = {
  borderBottom: "solid 1px",
  borderTop: "none",
  borderColor: "grey9",
  background: "background",
  width: "100%",
};

export const menuItemButton = {
  width: "100%",
  justifyContent: "flex-start",
  fontWeight: "400",
  color: "primary",
  height: "60px",

  svg: {
    height: "24px",
    width: "auto",
  },
};

export const closeMenuItemButton = {
  justifyContent: "center",
  fontWeight: "400",
  display: "flex",
  margin: "0 auto 22px",
};
